import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=2ae1c890&scoped=true&"
import script from "./Intro.vue?vue&type=script&lang=ts&"
export * from "./Intro.vue?vue&type=script&lang=ts&"
import style0 from "./Intro.vue?vue&type=style&index=0&id=2ae1c890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1c890",
  null
  
)

export default component.exports